import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, X } from 'lucide-react';
import { SectionHeading } from '@/components/SectionHeading';
import { TamilNaduMap } from '@/components/TamilNaduMap';
import { MagneticButton } from '@/components/MagneticButton';

export const MapSection = ({ locations = [] }) => {
  const [active, setActive] = useState(null);
  if (!locations.length) return null;
  return (
    <section className='relative bg-[#101517]'>
      <div className='grain absolute inset-0' />
      <div className='relative container-x py-20 lg:py-28'>
        <SectionHeading eyebrow='Our Service Reach' title='Engineered to operate where the project demands.' light
          intro='Head office in Coimbatore with branch offices in Karur and Chennai, and service coverage extending across Tamil Nadu.' />
        <div className='mt-14 grid gap-10 lg:grid-cols-12'>
          <div className='lg:col-span-7'>
            <TamilNaduMap locations={locations} activeName={active?.name} onSelect={setActive} />
          </div>
          <div className='lg:col-span-5'>
            <div className='rounded-2xl border border-white/10 bg-[#20272A] p-7'>
              <AnimatePresence mode='wait'>
                {active ? (
                  <motion.div key={active.name} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -8 }} transition={{ duration: 0.35 }}>
                    <div className='flex items-start justify-between'>
                      <div>
                        <span className={`eyebrow ${active.type === 'office' ? 'text-[#B88A3B]' : 'text-[#7fd4d9]'}`}>{active.label}</span>
                        <h3 className='mt-2 font-head text-3xl font-semibold text-[#F6F5F1]'>{active.name}</h3>
                      </div>
                      <button onClick={() => setActive(null)} className='text-[#F6F5F1]/40 hover:text-[#F6F5F1]'><X size={18} /></button>
                    </div>
                    {active.address && (
                      <p className='mt-4 flex items-start gap-2 text-sm text-[#F6F5F1]/70'><MapPin size={16} className='mt-0.5 shrink-0 text-[#B88A3B]' /> {active.address}</p>
                    )}
                    <p className='mt-4 text-sm text-[#F6F5F1]/70'>{active.blurb}</p>
                    <div className='mt-5 flex flex-wrap gap-2'>
                      {(active.services || []).map((s) => (
                        <span key={s} className='rounded-full border border-white/12 px-3 py-1 text-xs text-[#F6F5F1]/70'>{s}</span>
                      ))}
                    </div>
                  </motion.div>
                ) : (
                  <motion.div key='empty' initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                    <span className='eyebrow text-[#F6F5F1]/40'>Interactive Map</span>
                    <h3 className='mt-2 font-head text-2xl font-semibold text-[#F6F5F1]'>Select a location</h3>
                    <p className='mt-3 text-sm text-[#F6F5F1]/60'>Tap any marker to view office details and service coverage. Gold markers are offices; teal markers indicate service coverage.</p>
                    <div className='mt-6 grid grid-cols-2 gap-3'>
                      {locations.slice(0, 8).map((l) => (
                        <button key={l.name} onClick={() => setActive(l)} className='rounded-lg border border-white/10 px-3 py-2 text-left text-sm text-[#F6F5F1]/70 transition-colors hover:border-[#B88A3B]/50 hover:text-[#F6F5F1]'>
                          {l.name}
                        </button>
                      ))}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
              <div className='mt-7'>
                <MagneticButton to='/locations' variant='secondary' className='text-[#F6F5F1]' data-cursor='VIEW'>Full Service Reach</MagneticButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
